import { render, staticRenderFns } from "./AddResourcesMenu.vue?vue&type=template&id=24c44301"
import script from "./AddResourcesMenu.vue?vue&type=script&lang=js"
export * from "./AddResourcesMenu.vue?vue&type=script&lang=js"
import style0 from "./AddResourcesMenu.vue?vue&type=style&index=0&id=24c44301&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QMenu,QList,QItem,QItemSection,QIcon});
